import { useEffect } from 'react'

function useSchema(schema) {
  const serialized = schema ? JSON.stringify(schema) : null

  useEffect(() => {
    if (!serialized) return
    let el = document.getElementById('ld-json-schema')
    if (!el) {
      el = document.createElement('script')
      el.type = 'application/ld+json'
      el.id = 'ld-json-schema'
      document.head.appendChild(el)
    }
    el.textContent = serialized
    return () => {
      const existing = document.getElementById('ld-json-schema')
      if (existing) existing.remove()
    }
  }, [serialized])
}

export default useSchema
